import { IResponseState } from "../../components/Modals/ResponseModal/module/constants";
import {
  LOADER_IDENTIFIER,
  STATE_IDENTIFIER,
} from "./SecurityQuestionsConstants";

const { QUESTIONS, REQUEST_STATE } = STATE_IDENTIFIER;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [QUESTIONS]: [],
  [LOADER_IDENTIFIER]: false,
  [REQUEST_STATE]: IResponseState.PENDING,
};
